import { createAction } from 'redux-promise-middleware-actions';

export const types = {
  SET_OFFLINE_DRAFT_SAVED: 'SET_OFFLINE_DRAFT_SAVED',
  SET_OFFLINE_QUEUE_COUNT: 'SET_OFFLINE_QUEUE_COUNT',
  SET_SYNCING: 'SET_SYNCING',
  SET_SYNC_COMPLETE: 'SET_SYNC_COMPLETE',
  SET_PUSH_PERMISSION: 'SET_PUSH_PERMISSION',
  SET_PUSH_SUBSCRIBED: 'SET_PUSH_SUBSCRIBED'
};

export const setOfflineDraftSaved = createAction(
  types.SET_OFFLINE_DRAFT_SAVED,
  (timesheetId, savedAt) => ({ timesheetId, savedAt })
);

export const setOfflineQueueCount = createAction(
  types.SET_OFFLINE_QUEUE_COUNT,
  (count) => count
);

export const setSyncing = createAction(
  types.SET_SYNCING,
  (isSyncing) => isSyncing
);

export const setSyncComplete = createAction(
  types.SET_SYNC_COMPLETE,
  (syncedCount) => syncedCount
);

export const setPushPermission = createAction(
  types.SET_PUSH_PERMISSION,
  (permission) => permission
);

export const setPushSubscribed = createAction(
  types.SET_PUSH_SUBSCRIBED,
  (isSubscribed) => isSubscribed
);